export default __webpack_public_path__ + "static/media/houby_barva-min.f3c774fb.png";